import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommissionType, ContractDetails } from '@models/reports/reports';
import { Paginator, PaginatorItems, Table } from '@models/table';
import { firstValueFrom } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { ProfileDataModalComponent } from '../profile-data-modal/profile-data-modal.component';
import { ReportsService } from '@services/reports.service';
import { formatNumberToLocal } from 'src/app/utils/format-number-to-local';
import { CommissionEnum } from '@enums/commission';

@Component({
  selector: 'app-detail-viewer-modal',
  templateUrl: './detail-viewer-modal.component.html',
  styleUrl: './detail-viewer-modal.component.scss'
})
export class DetailViewerModalComponent extends ModalComponent<DetailViewerModalComponent> implements OnInit {

  public hasPermissionToExportExcel: boolean = true;
  public hasPermissionToExportPdf: boolean = true;
  public loading: boolean = false;
  public table: Table<ContractDetails> = this.createTable();
  @Input() isExportingExcelDetails: boolean = false;
  @Input() isExportingPdfDetails: boolean = false;
  @Output() onExportExcelDetail = new EventEmitter<any>();
  @Output() onExportPdfDetail = new EventEmitter<any>();

  public constructor(
    private readonly _datePipe: DatePipe,
    private readonly _dialog: MatDialog,
    private readonly _reportService: ReportsService,
    @Inject(MAT_DIALOG_DATA) public data: { commissionConfig: CommissionType, filters: any, hasPermissionToExportExcel: boolean, hasPermissionToExportPdf: boolean },
  ) {
    super();

    this.hasPermissionToExportExcel = data.hasPermissionToExportExcel;
    this.hasPermissionToExportPdf = data.hasPermissionToExportPdf;
  }

  ngOnInit(): void {

    if (this.data.commissionConfig.id == CommissionEnum.PAID_COMMISSIONS) {
      this.table.headers.splice(7, 0, {
        key: "periodCode",
        value: "Período"
      });
    }

    this.filter();
  }

  public pageChange(paginator?: Paginator): void {
    this.filter(paginator);
  }

  public async exportWorksheetReport(): Promise<any> {
    this.onExportExcelDetail.emit(this.table.paginator);
  }

  public async exportPdfReport(): Promise<void> {
    this.onExportPdfDetail.emit(this.table.paginator);
  }

  public filter(paginator?: Paginator): void {

    if (!paginator) {
      paginator = {
        index: 1,
        itensPerPage: [10, 15, 20, 50, 100],
        pageSize: 10,
      };
    }

    this.loading = true;

    firstValueFrom(
      this._reportService.getCommissionsDetailsReport(this.data.filters, paginator, this.data.commissionConfig.id)
    )
      .then((resp: PaginatorItems<any>) => {
        this.table.data = resp.items;
        this.table.paginator.length = resp.totalCount;
        this.table.paginator.index = paginator.index;
        this.table.paginator.pageSize = paginator.pageSize;
      })
      .finally(() => {
        this.loading = false;
      });
    }

  private createTable(): Table<ContractDetails> {
    return {
      headers: [
        {
          key: "contract",
          value: "Contrato",
        },
        {
          key: "groupCode",
          value: "Grupo",
        },
        {
          key: "quotaCode",
          value: "Cota",
        },
        {
          key: "version",
          value: "Versão",
        },
        {
          key: "sellerCpf",
          value: "CPF Vendedor",
        },
        {
          key: "assetValue",
          value: "Valor Bem",
        },
        {
          key: "saleDate",
          value: "Data da Venda",
        },
        {
          key: "installmentNumber",
          value: "Parcela Comissão",
        },
        {
          key: "commissionPercentage",
          value: "Comissão (%)",
        },
        {
          key: "reversalValue",
          value: "Estorno",
        },
        {
          key: "totalValue",
          value: "Valor Total",
        },
      ],
      data: [],
      style: {
        table: {
          height: "500px",
        },
        data: [
          {
            key: "saleDate",
            transform: (value) =>
              this._datePipe.transform(value, "dd/MM/yyyy"),
          },
          {
            key: "commissionPercentage",
            transform: (value) => value ? `${value}%` : "0%",
          },
          {
            key: "assetValue",
            transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A"
          },
          {
            key: "totalValue",
            transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A"
          }
        ],
      },
      buttons: {
        read: true,
      },
      paginator: {
        index: 1,
        itensPerPage: [10, 15, 20, 50, 100],
        pageSize: 10,
      },
      messageWithoutDates: "Não há dados para exibir no momento.",
    };
  }

  public viewProfileDataDetails(commissionDetail: any) {
    this._dialog.open(ProfileDataModalComponent, { data: commissionDetail });
  }

}
